export default __webpack_public_path__ + "static/media/gallery-02_full.1ffb09fb.jpg";